module.exports = __webpack_public_path__ + "img/salasa-dark.13091707.webp";